<template>
    <div class="p-grid data-table data-table-list">
        <div class="p-col-12">
            <div class="card">
                <DataTable :value="levels" editMode="cell" @cell-edit-complete="onCellEditComplete">
                    <template #header>
                        <h2>Direct levels</h2>
                    </template>
                    <Column v-for="col of columns" :field="col.field" :header="col.header" :key="col.field">
                        <template #editor="slotProps">
                            <InputText v-if="col.header === 'Percentage'" :value="slotProps.data[slotProps.column.field]" @input="onCellEdit($event, slotProps)" />
                            <span v-else>{{ slotProps.data[slotProps.column.field] }}</span>
                        </template>
                    </Column>
                </DataTable>
                <div class="save-btn">
                    <Button @click="save()" label="Save changes" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    /* eslint-disable */

    import SettingsService from '../../../service/SettingsService';
    import Vue from 'vue';

    export default {
        data() {
            return {
                levels: null,
                editingCellRows: {},
                editingRows: [],
                columns: null

            }
        },
        created() {
            this.$store.commit('setPageTitle', {pageTitle: 'Settings'});
            this.settingsService = new SettingsService();
            this.columns = [
                { field: 'level', header: 'Level' },
                { field: 'percentage', header: 'Percentage' }

            ];

            this.originalRows = {};


        },
        async mounted() {

            this.settingsService.getLevels(this.$store.state.currentUser.token).then(data => this.levels = data);


        },
        methods: {
            onCellEditComplete(event) {
                if (!this.editingCellRows[event.index]) {
                    return;
                }

                const editingCellValue = this.editingCellRows[event.index][event.field];

                switch (event.field) {
                    case 'percentage':
                        //if (this.isNumber(editingCellValue))
                        if (true)
                            Vue.set(this.levels, event.index, this.editingCellRows[event.index]);
                        else
                            event.preventDefault();
                        break;

                    default:
                        if (editingCellValue.length > 0)
                            Vue.set(this.levels, event.index, this.editingCellRows[event.index]);
                        else
                            event.preventDefault();
                        break;
                }
            },
            onCellEdit(newValue, props) {
                if (!this.editingCellRows[props.index]) {
                    this.editingCellRows[props.index] = { ...props.data };
                }

                this.editingCellRows[props.index][props.column.field] = newValue;
            },
            isNumber(val) {
                return typeof val === 'number';
            },
            async save() {
                await this.settingsService.saveLevels(this.levels, this.$store.state.currentUser.token);

            }

        }
    }





</script>

<style scoped>
</style>